import type { CommonSVGProps } from '../internal';

export const GmailIcon = (props: Pick<CommonSVGProps, 'height' | 'width'>) => (
  <svg fill="none" height={32} viewBox="0 0 32 32" width={32} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.91 26.91h4.363V16.327L1.045 11.647v13.082c0 1.205.977 2.182 2.182 2.182Z" fill="#4285F4" />
    <path d="M24.727 26.91h4.364a2.182 2.182 0 0 0 2.182-2.182V11.647l-6.546 4.68V26.91Z" fill="#34A853" />
    <path d="M24.727 7.273v9.054l6.546-4.68V8.364c0-3.026-3.456-4.752-5.876-2.938l-.67.502v1.345Z" fill="#FBBC04" />
    <path d="M7.273 16.327V7.273L16 13.818l8.727-6.545v9.054L16 22.873l-8.727-6.546Z" fill="#EA4335" />
    <path d="M1.045 8.364v3.283l6.228 4.68V7.273l-.67-.502C4.183 4.957.727 6.683.727 9.71v-1.345Z" fill="#C5221F" />
  </svg>
);
